import { MapProvider, Marker } from "@vis.gl/react-maplibre";
import { Fragment } from "react";
import { BaseMap } from "../components/map/BaseMap";
import { SpotMarker } from "../components/map/MapMarkers";
import styles from "./TestMarkersPage.module.css";

// Speeds (kn) spanning the full encode-able range, including the
// overpowered / extreme tail so the colour shifts on the active arc are
// visible. The arc's length flattens at 100% once kn >= 25, so anything
// past 25 is colour-only — that's the design we're verifying here.
const TEST_SPEEDS_KN = [0, 3, 5, 8, 10, 12, 15, 18, 20, 22, 25, 30, 40, 55];

// Lay markers out along a horizontal row across central Sweden. Spread
// chosen so a desktop-ish viewport (~1280px) fits all 14 markers without
// overlap at the page's initial zoom.
const ROW_LAT = 59;
const START_LON = 12;
const LON_STEP = 0.7;
const LABEL_LAT_OFFSET = 0.18;

export function TestMarkersPage() {
  return (
    <div className={styles.testPage}>
      <header className={styles.header}>
        <h1>SpotMarker test bench</h1>
        <p>
          Synthetic spots at fixed wind direction (270°, ideal SW) so only
          the speed arc varies. Each marker is labelled with its knots
          value above. The active marker test sits at the right of the row.
        </p>
      </header>
      <div className={styles.mapWrap}>
        <MapProvider>
          <BaseMap
            initialLongitude={START_LON + (TEST_SPEEDS_KN.length / 2) * LON_STEP}
            initialLatitude={ROW_LAT}
            initialZoom={6}
          >
            {TEST_SPEEDS_KN.map((kn, i) => {
              const lon = START_LON + i * LON_STEP;
              return (
                <Fragment key={kn}>
                  <Marker longitude={lon} latitude={ROW_LAT + LABEL_LAT_OFFSET} anchor="bottom">
                    <span className={styles.label}>{kn} kn</span>
                  </Marker>
                  <SpotMarker
                    longitude={lon}
                    latitude={ROW_LAT}
                    dirDeg={270}
                    speedMs={kn / 1.944}
                    idealDirs={["SW"]}
                  />
                </Fragment>
              );
            })}
            {/* Selected variant for comparison — render one extra at the
                end of the row so we can see the teardrop's arc behaviour
                alongside the disc variants. Use a sweet-spot speed
                (20 kn) so the arc fills past the 50% transition. */}
            <Marker
              longitude={START_LON + TEST_SPEEDS_KN.length * LON_STEP}
              latitude={ROW_LAT + LABEL_LAT_OFFSET}
              anchor="bottom"
            >
              <span className={styles.label}>20 kn · selected</span>
            </Marker>
            <SpotMarker
              longitude={START_LON + TEST_SPEEDS_KN.length * LON_STEP}
              latitude={ROW_LAT}
              dirDeg={270}
              speedMs={20 / 1.944}
              idealDirs={["SW"]}
              selected
            />
          </BaseMap>
        </MapProvider>
      </div>
    </div>
  );
}
